import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../../../shared/services/dialog.service';
import { Utility } from '../../../../common/utility';
import { AppMessages } from '../../../../shared/constants/messages';
import { AppConstants } from '../../../../shared/constants/constants';
import { TMBDataTableComponent } from '../../../../components/data-table/data-table.component';
import { SharedService } from '../../../../shared/services/share.services';
import { GroupTemplateService } from './group-template.service';
import { GroupWaitingModel } from '../../../../models/waiting-room/group-waiting.model';
import {
  ConsultationType,
  GroupConsultationStepInfo,
  GroupTemplateConsultationStepInfo
} from '../../../../models/consultation/consultation.model';
import { ModifyGroupTemplateComponent } from './modify-group-template-popup.component';
import { UserType } from '../../../../shared/constants/permission';
import { GroupTemplateInformationPopupComponent } from './group-template-information-popup/group-template-information-popup.component';
import { FormGroup, FormBuilder  } from '@angular/forms';
import { MdDatepickerInputEvent } from '@angular/material';

@Component({
  selector: 'app-group-template-list',
  templateUrl: 'group-template-list.component.html',
  providers: [GroupTemplateService]
})

export class GroupTemplateListComponent extends TMBDataTableComponent implements OnInit {
  @Output() refeshList: EventEmitter<any> = new EventEmitter();
  public dataRow = new Array<GroupWaitingModel>();
  public currentCountryId = localStorage.getItem(AppConstants.localStorage.countryId);
  public currentCentreId = localStorage.getItem(AppConstants.localStorage.centreId);
  public filterDataGrp: FormGroup;
  public filterData = {
    countryId: this.currentCountryId || null,
    groupTemplateName: '',
    groupDepartDate:'',
    centreId: this.currentCentreId || null
  };
  public countries = [];
  public centres = [];
  public isHasPermissionAddGroup = false;
  public isHasPermission = false;
  public departDate = null;
  constructor( private formBuilder: FormBuilder,
    public utility: Utility,
    public groupTemplateService: GroupTemplateService,
    public dialogService: DialogService,
    public sharedService: SharedService,
    private router: Router
  ) {
    super(sharedService);
  }

  ngOnInit() {
    const userType = localStorage.getItem(AppConstants.localStorage.userType);
    this.isHasPermissionAddGroup =  (userType === UserType.SystemAdmin || userType === UserType.CentreAdmin || userType === UserType.Practitioner) ? true : false;
    this.isHasPermission = (userType === UserType.SystemAdmin || userType === UserType.CentreAdmin) ? true : false;
    this.getListCountry();
    this.getCentre();
    this.setPage({ offset: 0 });
  }
   
  setPage(pageInfo,isUpdateLastedDate = true) {
    this.page.pageNumber = pageInfo.offset;
 
    let param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      countryId: this.filterData.countryId != 'null' ? this.filterData.countryId : null,
      groupName: this.filterData.groupTemplateName,
      centreid: this.filterData.centreId != 'null' ? this.filterData.centreId : null,
      departDate:  this.departDate
    };
    
    if(this.filterData.countryId && this.filterData.countryId !== 'null'){
      param['countryId'] = this.filterData.countryId;
    }
    
    this.groupTemplateService.getGroupTemplateList(param).subscribe
      (result => {
        if (result) {
          const data = result.json();
          this.dataRow = data['list'];
          this.page.totalElements = data['totalRecords'];
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          if (this.page.pageNumber + 1 > this.page.totalPages) {
            this.page.pageNumber = this.page.totalPages > 0 ? (this.page.totalPages - 1) : 0;
          }
        }
      });
  }

  getListCountry() {
    // Get list country here
    this.groupTemplateService.getListCountry().subscribe(
      result => {
        if (result) {
          const data = result.json();
          this.countries = data;
        }
      }
    );
  }
  getCentre() {
    this.groupTemplateService.getCentre().subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          if (data) {
            this.centres = data;
           // this.centreList.unshift(new CentreReport('-1', 'All Centres', false));
            //this.reportForm.controls.centre.setValue(this.centreList[0]);
          }
        }
      }
    );
  }
  onFilter() {
    this.setPage({ offset: 0 });
  }

  /**
   * function to reload the list when user change country
   */
  onChangeCountry() {
    this.setPage({ offset: 0 });
  }

  /**
   * function to show group template infomation
   * @param dataRow
   */
  onShowInformationGroup(dataRow) {
    const height = window.screen.height - (window.screen.height * 30 / 100);
    this.dialogService.openComponentDialog(GroupTemplateInformationPopupComponent, {
      groupId: dataRow.groupId,
      countries: this.countries,
      height: height
    }, { width: '80%', height: height + 'px' }).subscribe(result => {
      if (result) {

      }
    });
  }

  /**
   * Add new group template
   */
  onCreateGroupTemplate() {
    const param = {
      countryId: this.currentCountryId,
      countries: this.countries
    };
    this.dialogService.openComponentDialog(ModifyGroupTemplateComponent, param, { 'width': '800px' }).subscribe(
      result => {
        this.reloadPage(this.page.pageNumber, this.dataRow);
      }
    );
  }

  /**
   * Edit Group popup
   * @param groupId
   */
  onEditGroup(dataGroup) {
    const data = {
      groupId: dataGroup.id,
      countries: this.countries,
    };

    this.dialogService.openComponentDialog(ModifyGroupTemplateComponent, data, { 'width': '1100px' }).subscribe
      (result => {
        this.reloadPage(this.page.pageNumber, this.dataRow);
      });
  }

  /**
   * Remove group
   * @param groupId
   */
  onRemoveGroup(groupId: string) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.groupTemplateConsultant.removeGroupTemplate }).subscribe
      (result => {
        if (result) {
          // if user click yes then call API to remove group
          this.groupTemplateService.removeGroupTemplate(groupId).subscribe(
            deleteResult => {
              if (deleteResult) {
                // remove group success then reload list
                this.reloadPage(this.page.pageNumber, this.dataRow, true);
                this.refeshList.emit();
              }
            }
          );
        }
      });
  }

  /**
   * function to go to group consultation process
   * @param item
   */
  onConsultationGroup(item) {
    if (item.status === ConsultationType.Consultation) {
      //  move to the navigate to Trip Information page
      this.router.navigate([GroupTemplateConsultationStepInfo[0].routerLink, item.id]);
    } else {
      // move to the latest step in consultation process
      const groupConsultationStep = GroupTemplateConsultationStepInfo.filter(c => c.step === item.step);
      if (groupConsultationStep.length > 0) {
        this.router.navigate([groupConsultationStep[0].routerLink, item.id]);
      }
    }
  }

  onDepartDateChange(event) {
    this.departDate = this.utility.convertDateToString(event);// new Date(event.toDateString());    
  }

  onDepartDateInput(event) {
    this.departDate = this.utility.convertDateToString(event);// new Date(event.toDateString());    
  }
  refreshPage(isUpdateLastedDate = false) {
    this.setPage({ offset: this.page.pageNumber }, isUpdateLastedDate);
  }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group-template/group-template-list.component.ts